export var EPermissionGroup;
(function (EPermissionGroup) {
    EPermissionGroup["ALL_SHAREHOLDERS"] = "ALL_SHAREHOLDERS";
    EPermissionGroup["SPECIFIC_USER"] = "SPECIFIC_USER";
})(EPermissionGroup || (EPermissionGroup = {}));
